import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './auth'
import Landing from './pages/Landing'
import Flight from './pages/Flight'
import Fuel from './pages/Fuel'
import Expense from './pages/Expense'
import Entries from './pages/Entries'
import NotAuthorized from './pages/NotAuthorized'
import InstallPrompt from './components/InstallPrompt'

/** Guard: redirect unauthenticated users to landing (where sign-in lives). */
function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user } = useAuth()
  if (!user) return <Navigate to="/" replace />
  return <>{children}</>
}

function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/not-authorized" element={<NotAuthorized />} />
        <Route
          path="/flight"
          element={
            <RequireAuth>
              <Flight />
            </RequireAuth>
          }
        />
        <Route
          path="/fuel"
          element={
            <RequireAuth>
              <Fuel />
            </RequireAuth>
          }
        />
        <Route
          path="/expense"
          element={
            <RequireAuth>
              <Expense />
            </RequireAuth>
          }
        />
        <Route
          path="/entries"
          element={
            <RequireAuth>
              <Entries />
            </RequireAuth>
          }
        />
        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
      <InstallPrompt />
    </AuthProvider>
  )
}
